<template>
  <div>
    <!-- {{ value }} -->
    <v-card
      class="py-0"
      :class="
        $vuetify.breakpoint.xsOnly ? 'elevation-0 py-3 mobile_view__class' : ''
      "
      min-height="270px"
    >
      <v-card-text class="px-0 py-0">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            class="py-0"
            @mouseover="on_hover = true"
            @mouseleave="on_hover = false"
            @click="routeHandler"
          >
            <div
              class="video_container__class d-flex justify-center"
              v-bind:style="
                value.thumbnail
                  ? 'background-image: \
                  url(' +
                    this.value.thumbnail.file +
                    '),linear-gradient(0deg, #CFCFCF, #CFCFCF)'
                  : 'background:linear-gradient(0deg, #CFCFCF, #CFCFCF)'
              "
            >
              <!-- <video
                    :src="value.file"
                    :poster="value.thumbnail.file"
                    width="100%"
                  ></video> -->
              <!-- <video-component
                    :src="value.file"
                    :poster="value.thumbnail.file"
                    width="100%"
                    height="70%"
                  ></video-component> -->
              <div
                v-if="value.price"
                class="price_text_div__class price_text__class text-center pt-2"
              >
                ₹{{ value.price }}
              </div>
              <img
                class="playbutton__class"
                src="@/assets/video_course/play-circle.svg"
                alt=""
                v-if="on_hover"
                @click="routeHandler()"
              />
              <!-- <img :src="value.thumbnail.file" alt="" class="image__class" /> -->
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            class="py-0 py-2"
            style="min-height: 85px"
            @mouseover="verticaldot_hover = true"
          >
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.xsOnly ? 'px-0 pr-2' : 'px-4'"
            >
              <div class="video_title__class" v-if="value.status !== 'Draft'">
                {{ value.title }}
              </div>
              <div
                v-else
                class="pb-1"
                @click="
                  toggleVideoDetail({
                    show: true,
                    id: value.id,
                    detail: value.video,
                    type: 'edit',
                  })
                "
              >
                <span class="draft_video_title__class"
                  >+ Add Video details</span
                >
              </div>
              <v-spacer></v-spacer>
              <div v-if="!hide_action">
                <v-menu>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      style="min-width: 0px !important; padding: 0px !important"
                      v-if="$vuetify.breakpoint.smAndUp"
                    >
                      <v-icon color="#333333">mdi-dots-vertical</v-icon>
                    </v-btn>
                    <v-icon
                      v-else
                      color="#333333"
                      size="20"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-dots-vertical</v-icon
                    >
                  </template>
                  <v-list>
                    <v-list-item-group>
                      <v-list-item
                        v-for="(item, i) in action_list"
                        :key="i"
                        @click="actionHanlder(item.value)"
                      >
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div
              class="my-1"
              :class="$vuetify.breakpoint.xsOnly ? 'px-0 pr-2' : 'px-4'"
              v-if="value.status !== 'Verified' && is_same_user"
            >
              <v-chip :class="`${value.status} common_chip__class`">{{
                value.status
              }}</v-chip>
            </div>
            <div
              class="video_details_text__class mt-1"
              :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-4'"
              v-else
            >
              <span>{{ value.views_count }} Views</span>
              <v-icon color="rgba(51, 51, 51, 0.87)">mdi-circle-small</v-icon>
              <span>{{ value.time.split(",")[0] }} ago</span>
              <v-icon color="rgba(51, 51, 51, 0.87)">mdi-circle-small</v-icon>
              <span v-if="value.language">{{
                value.language.name_to_show
              }}</span>
            </div>
            <span
              :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-4'"
              v-if="!is_same_user"
              @click="routeToProfile(value.profile.user, value.profile.name)"
            >
              <!-- {{ $vuetify.breakpoint.xsOnly }} -->
              <avatar-or-initials
                :name="value.profile.name"
                :image="value.profile.profile_image"
                size="30"
              />
              <span
                class="black--text"
                :style="
                  $vuetify.breakpoint.smOnly
                    ? 'font-size:12px'
                    : 'font-size:14px'
                "
              >
                {{ value.profile.name }}</span
              >
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import helper from "@/helper/index";
import { mapActions } from "vuex";
import ROUTER_URL from "@/constant/urls";
import emitterKey from "@/helper/emitterKey";
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/newAxios";
import AvatarOrInitials from "@/components/AvatarOrInitials.vue";
export default {
  name: "VideoCard",
  components: {
    AvatarOrInitials,
    // VideoComponent: () => import("../VideoComponent/VideoComponent.vue"),
  },
  props: {
    value: {
      type: Object,
    },
    user_id: {
      default: null,
      type: Number,
    },
    hide_action: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      on_hover: this.$vuetify.breakpoint.smAndUp ? false : true,
      verticaldot_hover: this.$vuetify.breakpoint.smAndUp ? false : true,
      action_list1: [
        {
          name: "Edit",
          value: "edit",
        },
        {
          name: "View",
          value: "view",
        },
        {
          name: "Delete",
          value: "delete",
        },
      ],
      action_list2: [
        {
          name: "View",
          value: "view",
        },
      ],
    };
  },
  computed: {
    user_id_check() {
      if (this.user_id) {
        return this.user_id;
      } else {
        return this.$route.query.id;
      }
    },
    is_same_user() {
      return helper.isSameUser(this.user_id_check);
    },
    action_list() {
      if (this.is_same_user) {
        return this.action_list1;
      } else {
        return this.action_list2;
      }
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      toggleVideoDetail: "videoCourse/toggleVideoDetail",
      snackBar: "snackBar/showSnack",
      toggleDeleteModal: "deleteModal/toggleDeleteModal",
    }),
    routeToProfile(user_id, name) {
      helper.goToProfile(user_id, name);
    },

    actionHanlder(value) {
      switch (value) {
        case "edit":
          this.toggleVideoDetail({
            show: true,
            id: this.value.id,
            detail: value.video,
            type: "edit",
          });
          break;
        case "view":
          this.routeHandler();
          break;
        case "delete":
          this.deleteHandler();
          break;
        default:
          break;
      }
    },
    routeHandler() {
      if (this.value.status === "Draft") {
        this.snackBar({
          text: "This video is saved as draft, To view it please fill required infomation and proceed",
          color: "warning",
          timeout: 4500,
        });
        return;
      }
      let obj = {};
      obj["vdid"] = this.value.id;
      obj["usid"] = this.user_id_check;
      if (this.value.playlist) {
        obj["type"] = "playlist";
        obj["ptid"] = this.value.playlist.id;
        obj["vdid"] = this.value.id;
      } else {
        obj["type"] = "video";
      }
      this.$router.push({
        name: ROUTER_URL.userPanel.children.videoDetail.name,
        // query: { vdid: this.value.id, usid: this.user_id_check },
        query: obj,
      });
      // this.snackBar({
      //   text: "Under Progress",
      //   color: "warning",
      //   timeout: 4500,
      // });
    },
    deleteHandler() {
      this.toggleDeleteModal({
        show: true,
        suffix: "this video",
        emit:
          emitterKey.DELETE_VIDEO +
          String(this.value.id) +
          String(this.value.id),
        id: this.value.id,
      });
    },
    deleteVideo(id) {
      const onSuccess = () => {
        this.snackBar({
          text: "Deleted",
          color: "success",
          timeout: 4500,
        });
        this.eventBus.$off(
          emitterKey.DELETE_VIDEO +
            String(this.value.id) +
            String(this.value.id)
        );
        this.eventBus.$emit(emitterKey.UPDATE_VIDEO_PLAYLIST);
      };
      const onFailure = () => {};
      let params = {};
      params["id"] = id;
      Axios("delete", apiUrl.VIDEO_DETAIL_API, {
        params,
        onSuccess,
        onFailure,
      });
    },
  },
  mounted() {},
  created() {
    this.eventBus.$on(
      emitterKey.DELETE_VIDEO + String(this.value.id) + String(this.value.id),
      (id) => {
        this.deleteVideo(id);
      }
    );
  },
  destroyed() {
    this.eventBus.$off(
      emitterKey.DELETE_VIDEO + String(this.value.id) + String(this.value.id)
    );
  },
};
</script>
<style scoped>
* {
  cursor: pointer;
}
.mobile_view__class {
  background: none !important;
}
.video_container__class {
  max-width: 100%;
  width: 100%;
  height: 154px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  object-position: center;
  object-fit: contain;
  background-size: cover;
  background-position: center;
}
.video_title__class {
  width: 90%;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 26px;
  /* or 162% */

  color: #333333;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 5px;
}
.draft_video_title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 157% */

  /* Primary */

  color: #2d8cff;
}
.video_details_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;

  color: rgba(51, 51, 51, 0.87);
}
span.v-chip.common_chip__class {
  border-radius: 4px;
}
span.v-chip.Under {
  background: #fef4eb;
  border: 1.5px solid #f2994a;
  border-radius: 4px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;

  /* Orange */

  color: #f2994a;
}
/*
span.v-chip.Verified {
}
*/
span.v-chip.Rejected {
  background: #f9e9eb;
  border: 1.5px solid #eb5757;
  border-radius: 4px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;

  color: #eb5757;
}
span.v-chip.Draft {
  background: #f2f2f2;
  border: 1.5px solid #a2a2a2;
  border-radius: 4px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;

  color: #a2a2a2;
}
.price_text_div__class {
  position: absolute;
  min-width: 56px;
  width: 56px;
  height: 26px;
  top: 0px;
  right: 0px;

  background: #b1d5ff;
  border-radius: 0px 12px;
}
.playbutton__class {
  position: absolute;
  top: 50px;
}
.price_text__class {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  color: #093060;
}
img.image__class {
  object-fit: cover;
}
@media all and (min-width: 1000px) {
}

@media all and (max-width: 600px) {
  .video_title__class {
    font-size: 14px;
    line-height: 22px;
  }
  .video_details_text__class {
    font-size: 10px;
    line-height: 14px;
  }
  .draft_video_title__class {
    font-size: 14px;
    line-height: 22px;
  }
  .price_text_div__class {
    left: 0px;
    border-radius: 12px 0px;
    border-top-left-radius: 0px;
  }
  .video_container__class {
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
}
</style>
